module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljiro-1@3x.ver2_0_2.jpg?aa8ef262";